import React, { Component } from 'react';
import PotentialUser from './PotentialUser.js';
import GetSequences from 'search/GetSequences.js';
import { InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';
import ConditionedComponent from 'components/ConditionedComponent.js';
import ethereum from 'decentralized/ethereum.js';

class GuildDetailView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            addingMember: false,
            users: [],
        };
    }

    editGuildName() {
        this.props.onNameChange(this.props.guild.name);
    }

    addMember(adding=true) {
        if (adding) {
            this.getPotentialUsers();
        }
        this.setState({
            addingMember: adding
        });
    }

    async getPotentialUsers() {
        // search sequences for users
        let get = new GetSequences(ethereum, false);

        await get.executeQuery();

        while ((await get.getNext()) !== undefined) {
            this.setState({
                users: await this.getUsersFromResults(get.results)
            });
        }
        this.setState({
            users: await this.getUsersFromResults(get.results)
        });
    }

    async getUsersFromResults(results) {
        let users = new Set();
        for (let i in results) {
            users.add(results[i].user);
        }


        let members = new Set(this.props.guild.members.map(
            x => x.userId.trim().toUpperCase()));

        users = Array.from(users);
        let userNames = {};
        for (let i in users) {
            let userId = users[i].trim();
            /*
            if (members.has(userId.toUpperCase())) {
                continue;
            }
            */
            let userName = await ethereum.users.getUserName(userId);
            userNames[userId] = userName;
        }

        return userNames;
    }

    render() {
        let guild = this.props.guild;
        return (
            <div className="guild-details">
              <div className="details-header">
                <ConditionedComponent condition={this.props.isEditingName}>
                  <InputGroup className="guild-name-input-group">
                    <Input onChange={(event) => this.props.onNameChange(event.target.value)}
                      value={this.props.name}
                      placeholder="Type name for guild" id="guild-name-input"/>
                </InputGroup>
                </ConditionedComponent>
                <ConditionedComponent condition={!this.props.isEditingName}>
                <div
                  onClick={() => this.editGuildName()}
                  className="guild-name">
                  {guild.name}
                </div>
                </ConditionedComponent>
              <div className="make-default-button">
                Make Default Guild
              </div>
              </div>
              {this.getAddMemberFlow()}
              {this.getShowMembersFlow()}
            </div>
        );
    }

    getAddMemberFlow() {
        if (!this.state.addingMember) {
            return (<div></div>);
        }

        return (
            <div>
              <div className="add-members-header">Add member</div>
              {Object.keys(this.state.users).map(
                  userId => 
                      <PotentialUser
                            isSelected={this.props.usersSelected.has(userId)}
                            onClick={() => this.props.selectUser(userId)}
                            userId={userId} userName={this.state.users[userId]}/>
              )}

            </div>
        );
    }

    getShowMembersFlow() {
        if (this.state.addingMember) {
            return (<div></div>);
        }
        return (
            <div>
              <div className="members-heading">
                <div>Members</div>
                <div onClick={() => this.addMember()} className="add-member-button">+</div>
              </div>
              <div className="guild-members">
                {this.props.guild.members.map(member => <GuildMember member={member}/>)}
              </div>
            </div>
        );
    }
}

class GuildMember extends Component {
    render() {
        return (
            <div className="guild-member">{this.props.member.userName}</div>
        );
    }
}

export default GuildDetailView;
